module.exports = __webpack_public_path__ + "img/BBVA.262e8a0.png";